import PropTypes from "prop-types";
import React from "react";

import DeleteDestinationForm from "v2/components/responsive/DeleteDestinationForm";

const DeleteDestinationPage = (props, context) => {
  const {location: {query}, params: {date, id, routeId}, router} = context;
  return (
    <DeleteDestinationForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}/${id}`,
          query,
        });
      }} />
  );
};

DeleteDestinationPage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default DeleteDestinationPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/DeleteDestinationPage.js
 **/